<template>
  <li
    style="cursor: pointer; padding-right:0"
    class="list-group-item d-flex"
    data-bs-toggle="modal"
    :data-bs-target="`#e${currentEmail.email_id}`"
  >
    <div class="activity-container">
      <span class="activities-date float-right">
        {{
          currentEmail.created_at
            | formatDate({
              format: getUserProfile.format_date,
              timezone: getUserProfile.timezone,
              hasHourAndMinutes: false,
            })
        }}
      </span>
    </div>

    <div class="activities-body d-flex" style="width: 100%;">
      <div class="email-header-one" style="padding:0 12px">
        <p class="d-flex">
          <span style="margin:-1.5px 5px 0 0">
            <SvgHelper :name="currentEmail.sent_by_candidate ? 'envelopeIn' : 'envelopeOut'" />
          </span>
          {{ currentEmail.sender_name }}
        </p>
        <p>
          {{ currentEmail.subject }}
        </p>
        <p>
          {{
            currentEmail.email_timestamp
              | formatDate({
                format: getUserProfile.format_date,
                timezone: getUserProfile.timezone,
                hasHourAndMinutes: true,
              })
          }}
        </p>
      </div>
    </div>
    <div
      class="modal fade"
      :id="`e${currentEmail.email_id}`"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Email</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="email-header">
              <ul class="list-unstyled">
                <li>
                  <span>From</span> {{ currentEmail.sender_name }} &lt;{{
                    currentEmail.sender_email
                  }}&gt;
                </li>
                <li>
                  <span>To</span> {{ currentEmail.recipient_name }} &lt;{{
                    currentEmail.recipient_email
                  }}&gt;
                </li>
                <li>
                  <span>Date</span>
                  {{
                    currentEmail.email_timestamp
                      | formatDate({
                        format: getUserProfile.format_date,
                        timezone: getUserProfile.timezone,
                        hasHourAndMinutes: true,
                      })
                  }}
                </li>
                <li><span>Subject</span> {{ currentEmail.subject }}</li>
                <li v-if="currentEmail.attachments.length > 0">
                  <span>Attachments</span>
                  <span v-for="attach in currentEmail.attachments" :key="attach.id">
                    <span @click="onDownloadDocument(attach.id, attach.name)">{{
                      attach.name
                    }}</span>
                  </span>
                </li>
              </ul>
            </div>
            <div class="email-body" v-html="popEmail(currentEmail.body)"></div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import CustomMainModal from '../../Modals/CustomMainModal';
import SvgHelper from '../../common/svgHelper';
import { mapGetters } from 'vuex';
// import ErrorList from '@/components/common/errorsList';
import axios from 'axios';
import { errorService } from '../../../services/errorService';

export default {
  components: {
    CustomMainModal,
    SvgHelper,
  },
  props: {
    height: {
      type: String,
      default: '865px',
    },
    emails: {
      type: Array,
      default: () => [],
    },
    currentEmail: {
      type: Object,
    },
  },
  data: () => ({
    id: '',
  }),
  methods: {
    popEmail(body) {
      if (!body) return '';

      const trimmed = body.trim();

      const isHtml =
        /<html[\s>]/i.test(trimmed) ||
        /<body[\s>]/i.test(trimmed) ||
        /<head[\s>]/i.test(trimmed) ||
        /<div[\s>]/i.test(trimmed) ||
        /<p[\s>]/i.test(trimmed) ||
        /<table[\s>]/i.test(trimmed) ||
        /xmlns:o=/i.test(trimmed);

      if (!isHtml) {
        return trimmed.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>');
      }

      // Parse HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(trimmed, 'text/html');

      // Remove <style> tags
      doc.querySelectorAll('style').forEach(el => el.remove());

      // Remove style attributes
      doc.querySelectorAll('*').forEach(el => {
        el.removeAttribute('style');
      });

      return doc.body.innerHTML;
    },
    onDownloadDocument(docId, docTitle) {
      axios
        .get(`${process.env.VUE_APP_API_URL}/admin/emailattachments/preview/${docId}`, {
          responseType: 'blob',
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${docTitle}`);
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
  },
  computed: {
    ...mapGetters(['getUserProfile']),
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.email-header-one {
  width: 100%;
  display: flex;
  justify-content: space-between;
  p {
    width: 33%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
    &:last-of-type {
      text-align: right;
      width: 25%;
    }
  }
}

.svg-icon {
  width: 15px;
  height: auto;
}

/* .activities-date {
    position: absolute;
    display: block;
    white-space: nowrap;
    right: 15px;
    color: #000;
    font-size: 13px;
  } */

.candidate-aside .scroll-emails {
  height: 628px !important;
}

li {
  padding-left: 0 !important;
}

#emails {
  .card {
    margin: 0;
  }
}

/* #emails {
    h6 {
      font-size: 18px;
      font-family: $font-family-sans-serif;
    }
  
    .activities-media li {
      border-radius: 0 !important;
      border: 0;
    }
  
    .activities-media li:nth-child(odd) {
      border-left: 5px solid #f05a00;
      background-color: #f1f1f3;
    }
  
    .activities-media li:nth-child(even) {
      border-left: 5px solid #747674;
    }
  
    .activities-name {
      font-family: Lato;
      color: $color-base-blue;
      letter-spacing: 0.9px;
      margin: 0;
    }
  
    .activities-status-color {
      color: #f05a00;
    }
  } */

.scroll-emails {
  overflow: hidden;
}

.activities-media {
  overflow-y: auto;
  figure {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    margin: 0 15px 0 10px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 0;
      object-fit: cover;
    }
  }

  p {
    margin: 0;
  }

  .activities-date {
    font-size: 13px;

    position: absolute;
    display: block;
    white-space: nowrap;
    right: 15px;
    color: #000;
    font-size: 13px;
  }
}

.modal-body {
  margin-top: 0;
  padding-top: 0;
  .email-header {
    margin: 12px 0;
    .list-unstyled {
      li {
        background: none !important;
        border-left: none !important;
        border-bottom: 1px solid #ddd !important;
        padding: 6px 0 !important;
        span {
          font-weight: 600;
          display: inline-block;
          min-width: 100px;
        }
      }
    }
  }
  .email-body {
    max-height: 520px;
    overflow-x: auto;
    /*  white-space: pre-wrap; */
  }
}

.embed-emails {
  .list-unstyled {
    li {
      font-size: 16px;
      border-bottom: 1px dashed #ddd;
      padding: 8px 0;
      span {
        color: #666;
        display: inline-block;
        min-width: 80px;
      }
    }
  }
  .list-unstyled.bottom {
    li {
      font-size: 14px;
      padding: 0;
      margin: 0;
      span {
        color: #111;
        font-weight: 700;
        min-width: auto;
        margin-right: 12px;
      }
    }
  }
  .views {
    max-height: 57vh;
    min-height: 57vh;
    overflow-y: auto;
    .single-email {
      border-bottom: 1px solid #000;
      padding: 20px 0;
      margin-bottom: 12px;
      p {
        font-size: 16px;
      }
    }
  }
}
@media only screen and (max-width: 1251px) {
  .card {
    border-bottom-left-radius: 18px !important;
    border-bottom-right-radius: 18px !important;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    border: none;
    border-radius: 0 !important;
    margin-top: 22px !important;
    h6 {
      display: none;
    }
  }
}

@media only screen and (max-width: 768px) {
  .card {
    border: none;
    border-radius: 0 !important;
    margin-top: 22px !important;
    h6 {
      display: none;
    }
  }
}

@media only screen and (max-width: 576px) {
  .activities-media {
    overflow: visible;
    height: auto !important;
  }
  .card {
    margin-top: 12px !important;
    border-radius: 0;
    border: none;
  }
  h6 {
    display: block !important;
  }
}
</style>
